import "./SEOAgencyAlternativeUk.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Comparison from "./sections/Comparison";
import Services from "./sections/Services";
import WhyConsultancy from "./sections/WhyConsultancy";
import AudienceGrid from "./sections/AudienceGrid";
import Process from "./sections/Process";
import Faq from "./sections/Faq";
import FinalCta from "./sections/FinalCta";
import Footer from "@/reusable_sections/Footer";
export default function SEOAgencyAlternativeUkPage() {
  return <div>
      <Header />
      <Hero />
      <Comparison />
      <Services />
      <WhyConsultancy />
      <AudienceGrid />
      <Process />
      <Faq />
      <FinalCta />
      <Footer />
    </div>;
}